import { CloseOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import React, { useEffect, useState } from "react";
import { $t, i18n } from "~/i18n.js";

export const SleepHoogteEdit = ({ currentHeight, saveHeight, readOnly }) => {
  const [newHeight, setNewHeight] = useState(currentHeight);
  useEffect(() => setNewHeight(currentHeight), [currentHeight]);

  const handleSave = async () => {
    if (newHeight !== currentHeight) {
      await saveHeight(newHeight);
    }
  };

  const handleClear = () => {
    setNewHeight(0);
    saveHeight(0);
  };

  return (
    <div
      className="row"
      style={{
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <p style={{ marginRight: 6 }}>
        {$t("Sleephoogte")} {i18n.height_unit === "m" ? "(m)" : "(ft)"}:{" "}
      </p>
      
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <Input
          type="number"
          allowClear={false}
          disabled={readOnly}
          step={ i18n.height_unit === "m" ? 10 : 50 }
          style={{
            width: 45,
            padding: "2px 4px",
          }}
          value={Math.round(Number(i18n.convertHeightToLocale(Number(newHeight) || 0)))}
          onChange={(element) => {
            setNewHeight(
              i18n.convertLocaleHeightToMetric(Number(element.target.value) || 0)
            );
          }}
          onPressEnter={handleSave}
          onBlur={handleSave}
        />
        
        <Button
          type="text"
          size="small"
          disabled={readOnly}
          icon={<CloseOutlined />}
          onClick={handleClear}
          style={{
            minWidth: 24,
            width: 24,
            height: 24,
            padding: 0,
          }}
        />
      </div>
    </div>
  );
};
